var _ConditionalRadioGroup;
import Component from '@glimmer/component';
import { hash } from '@ember/helper';
import { EmberChangeset } from 'ember-changeset';
import ChangesetAlignedFieldsRadioGroup from 'ui-kit/components/changeset/aligned-fields-radio-group';
import ChangesetBasicRadioGroup from 'ui-kit/components/changeset/basic-radio-group';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class ConditionalRadioGroup extends Component {
  get showConditionalBlock() {
    return this.args.changeset.get(this.args.propertyName) === this.args.conditionalValue;
  }
}
_ConditionalRadioGroup = ConditionalRadioGroup;
setComponentTemplate(precompileTemplate("\n    {{yield (hash BasicRadioGroup=(component ChangesetBasicRadioGroup changeset=@changeset propertyName=@propertyName isReadOnly=@isReadOnly) AlignedFieldsRadioGroup=(component ChangesetAlignedFieldsRadioGroup changeset=@changeset propertyName=@propertyName isReadOnly=@isReadOnly)) this.showConditionalBlock}}\n  ", {
  strictMode: true,
  scope: () => ({
    hash,
    ChangesetBasicRadioGroup,
    ChangesetAlignedFieldsRadioGroup
  })
}), _ConditionalRadioGroup);